import * as yup from 'yup';
import { useI18n } from 'vue-i18n';

export function getGeneralRules() {
   const { t } = useI18n();

   return {
      name: yup
         .string()
         .min(2, t('job-board.settings.errors.min-length', { min: 2 }))
         .required(t('job-board.settings.errors.required')),
      url: yup
         .string()
         .min(2, t('job-board.settings.errors.min-length', { min: 2 }))
         .matches(/^[a-z0-9]+(-[a-z0-9]+)*$/, t('job-board.settings.errors.url-domain'))
         .required(t('job-board.settings.errors.required')),
   };
}

export function getHeaderRules() {
   const { t } = useI18n();

   return {
      home_url: yup.string().nullable().url(t('job-board.settings.errors.url')),
      language_ids: yup
         .array()
         .min(1, t('job-board.settings.errors.min-array', { min: 1 }))
         .required(t('job-board.settings.errors.required')),
   };
}

export function getFooterRules() {
   const { t } = useI18n();

   return {
      contact_email: yup.string().email(t('job-board.settings.errors.invalid-email')).nullable(),
      social_urls: yup.object().shape({
         facebook: yup.string().nullable().url(t('job-board.settings.errors.url')),
         x: yup.string().nullable().url(t('job-board.settings.errors.url')),
         linkedin: yup.string().nullable().url(t('job-board.settings.errors.url')),
         instagram: yup.string().nullable().url(t('job-board.settings.errors.url')),
      }),
   };
}

export function getThemeRules() {
   const { t } = useI18n();

   return {
      border_radius: yup
         .mixed()
         .transform((_value, originalValue) => {
            // optional, empty values are transformed to undefined and pass validation
            if (originalValue === '' || originalValue === null || originalValue === undefined) {
               return undefined;
            }

            return Number(originalValue);
         })
         // .number().integer().min(0).optional() does not work as expected, use custom test
         .test('is-valid-number', t('job-board.settings.errors.number'), (value) => {
            if (value === undefined || value === null) {
               return true;
            }
            return typeof value === 'number' && Number.isInteger(value) && value >= 0;
         })
         .optional()
         .nullable(),
   };
}

export function getAllRules() {
   return yup.object({
      ...getGeneralRules(),
      ...getHeaderRules(),
      ...getFooterRules(),
      ...getThemeRules(),
   });
}
